function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "e-apm\\u0101c\\u012Bba",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "04.-E---apm\\u0101c\\u012Bba---Kontroljaut\\u0101jums",
  transform: "translate(-30.000000, -299.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Menu",
  transform: "translate(0.000000, 202.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Menu-item-with-submenus",
  transform: "translate(0.000000, 83.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(30.000000, 14.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "icon-base",
  x: 0,
  y: 0,
  width: 22,
  height: 22,
  rx: 3
}), /*#__PURE__*/React.createElement("g", {
  id: "icon",
  transform: "translate(1.000000, 2.000000)",
  stroke: "#079DC1",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0 L6,0 C8.209139,0 10,1.790861 10,4 L10,18 C10,16.3431458 8.65685425,15 7,15 L0,15 L0,0 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20,0 L14,0 C11.790861,0 10,1.790861 10,4 L10,18 C10,16.3431458 11.3431458,15 13,15 L20,15 L20,0 Z",
  id: "Path"
})))))));

function SvgIcSidenavOnlineSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "84315CAB-CC31-4A14-9FE0-FE7BCBB50313") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSidenavOnlineSelected);
export default __webpack_public_path__ + "static/media/ic-sidenav-online-selected.b7a0ded8.svg";
export { ForwardRef as ReactComponent };